define.alias("shared/utils/hash-code", "media/utils/platform-check");